export default __webpack_public_path__ + "static/media/search-solid.e4f96b3d.svg";